import { request } from '@/shared/api/request'

export const edit = (payload) => {
	return request({ url: 'contract/update/' + payload.externalId, method: 'POST', data: payload })
}

export const sendContract = (payload) => {
	return request({ url: 'contract/sendContract', method: 'POST', data: payload })
}
